import { render, staticRenderFns } from "./TalentWork.vue?vue&type=template&id=1703360f&scoped=true"
import script from "./TalentWork.vue?vue&type=script&lang=js"
export * from "./TalentWork.vue?vue&type=script&lang=js"
import style0 from "./TalentWork.vue?vue&type=style&index=0&id=1703360f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1703360f",
  null
  
)

export default component.exports